module.exports = __webpack_public_path__ + "static/media/notimg2.2fc972b0.svg";